(function () {
  if (window.CxProyectoApp) return;
  var KEY = 'cx_garage';
  var PJ = [
    { k: 'coil', n: 'Coilovers', q: 'coilover' },
    { k: 'lock', n: 'Kit de ángulo', q: 'kit ángulo' },
    { k: 'fdm', n: 'Freno de mano hidráulico', u: '/collections/frenado-frenos-de-mano' },
    { k: 'seat', n: 'Baquet y arnés', u: '/collections/interior-bases-de-asientos-asientos' },
    { k: 'whl', n: 'Llantas', u: '/collections/llantas' },
    { k: 'brk', n: 'Frenos de alto rendimiento', u: '/collections/frenado-kits-de-frenos-grandes' },
    { k: 'ic', n: 'Intercooler', u: '/collections/sistema-de-admision-intercoolers' },
    { k: 'exh', n: 'Escape', u: '/collections/escape' },
    { k: 'aero', n: 'Aero y carrocería', u: '/collections/carroceria' }
  ];
  var STAGES = ['Serie', 'Calle', 'Track day', 'Competición'];
  var CHK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12 5 5 9-10"/></svg>';
  var CFG = {}; try { CFG = JSON.parse(document.getElementById('CxGarCfg').textContent); } catch (e) {}
  var tab = 'all', idx = -1, box = null;
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function load() { try { var d = JSON.parse(localStorage.getItem(KEY) || 'null'); if (d && d.cars) return d; } catch (e) {} return { cars: [], a: 0 }; }
  function save(d) { try { localStorage.setItem(KEY, JSON.stringify(d)); } catch (e) {} }
  function pOf(c) { return (c && c.p && typeof c.p === 'object') ? c.p : {}; }
  function count(c) { var p = pOf(c), m = 0, w = 0; PJ.forEach(function (x) { if (p[x.k] === 'm') m++; else if (p[x.k] === 'w') w++; }); return { m: m, w: w }; }
  function stageOf(m) { return m >= 8 ? 3 : m >= 5 ? 2 : m >= 3 ? 1 : 0; }
  function shortName(c) { return c.g ? (c.m && c.g.indexOf(c.m) < 0 && c.m.length < 10 ? c.m + ' ' + c.g : c.g) : c.m; }
  function carName(c) { return [c.b, c.m, c.g].filter(Boolean).join(' '); }
  function pageFor(c) {
    var ps = CFG.pages || [];
    for (var i = 0; i < ps.length; i++) {
      var p = ps[i];
      if (p.b && p.b !== c.b) continue;
      if (p.m && p.m !== c.m) continue;
      if (p.g && (!c.g || p.g.indexOf(c.g) < 0)) continue;
      if (!p.b && !p.m && !p.g) continue;
      return p.h;
    }
    return null;
  }
  function carUrl(c) { var h = pageFor(c); return h ? '/collections/' + h : '/search?type=product&q=' + encodeURIComponent(carName(c)); }
  function urlOf(x, c) { return x.u ? x.u : '/search?type=product&q=' + encodeURIComponent(x.q + ' ' + (c.g || c.m || '')); }
  function nextOf(c) { var p = pOf(c); return PJ.filter(function (x) { return p[x.k] === 'w'; })[0] || PJ.filter(function (x) { return !p[x.k]; })[0] || null; }
  function isHere(u) {
    var a = document.createElement('a'); a.href = u;
    if (a.pathname.replace(/\/$/, '') !== location.pathname.replace(/\/$/, '')) return false;
    if (a.pathname.indexOf('/search') !== 0) return true;
    var q1 = new URLSearchParams(a.search).get('q') || '', q2 = new URLSearchParams(location.search).get('q') || '';
    return q1.trim().toLowerCase() === q2.trim().toLowerCase();
  }
  function findCar() {
    var d = load(), order = [d.a].concat(d.cars.map(function (_, i) { return i; }));
    for (var j = 0; j < order.length; j++) { var c = d.cars[order[j]]; if (c && isHere(carUrl(c))) return order[j]; }
    return -1;
  }

  /* Bloque dentro de la página del coche */
  function render() {
    if (!box) return;
    var d = load(), c = d.cars[idx]; if (!c) { box.remove(); box = null; return; }
    var p = pOf(c), ct = count(c), st = stageOf(ct.m), nx = nextOf(c), sn = esc(shortName(c));
    var bar = '', lbl = '';
    for (var i = 0; i < 4; i++) { bar += '<i' + (i <= st ? ' class="is-on"' : '') + '></i>'; lbl += '<span' + (i === st ? ' class="is-on"' : '') + '>' + STAGES[i] + '</span>'; }
    var items = PJ.filter(function (x) { return tab === 'all' || (tab === 'm' ? p[x.k] === 'm' : p[x.k] === 'w'); });
    var list = items.map(function (x) {
      var v = p[x.k] || '', n = PJ.indexOf(x) + 1;
      return '<li class="cxp__it' + (v ? ' is-' + v : '') + '"><span class="cxp__ic">' + (v === 'm' ? CHK : n) + '</span>' +
        '<span class="cxp__nm"><b>' + esc(x.n) + '</b><a href="' + esc(urlOf(x, c)) + '">Ver ' + esc(x.n.toLowerCase()) + ' para tu ' + sn + '</a></span>' +
        '<span class="cxp__act"><button type="button" class="cxp__m" data-cxp-set="' + x.k + '|m" aria-pressed="' + (v === 'm') + '">' + (v === 'm' ? '✓ Montado' : 'Montado') + '</button>' +
        '<button type="button" data-cxp-set="' + x.k + '|w" aria-pressed="' + (v === 'w') + '">' + (v === 'w' ? '★ Lo quiero' : 'Lo quiero') + '</button></span></li>';
    }).join('');
    if (!items.length) list = '<li class="cxp__empty">' + (tab === 'm' ? 'Aún no has marcado piezas montadas.' : 'Aún no has marcado piezas que quieras.') + '</li>';
    var next = nx ? '<div class="cxp__next"><small>Tu siguiente paso</small><strong>' + esc(nx.n) + ' para tu ' + sn + '</strong><p>' + (p[nx.k] === 'w' ? 'Lo tienes en tu lista. Mira los que valen para tu coche.' : 'Es lo siguiente que le falta a tu proyecto.') + '</p><a href="' + esc(urlOf(nx, c)) + '">Ver los que valen →</a></div>'
      : '<div class="cxp__next"><small>Proyecto completo</small><strong>Tu ' + sn + ' está a tope</strong><p>Lo tienes todo montado. Abajo tienes más piezas para seguir mejorándolo.</p></div>';
    box.innerHTML = '<div class="cx-wrap">' +
      '<div class="cxp__head"><div><small>Mi proyecto · en tu garaje</small><h2>Tu ' + sn + '</h2><p>Marca lo que ya llevas montado y lo que quieres. Te diremos qué te falta.</p></div>' +
        '<div class="cxp__tabs" role="group" aria-label="Filtrar piezas"><button type="button" data-cxp-tab="all" class="' + (tab === 'all' ? 'is-on' : '') + '">Todo (' + PJ.length + ')</button><button type="button" data-cxp-tab="m" class="' + (tab === 'm' ? 'is-on' : '') + '">Montado (' + ct.m + ')</button><button type="button" data-cxp-tab="w" class="' + (tab === 'w' ? 'is-on' : '') + '">Lo quiero (' + ct.w + ')</button></div></div>' +
      '<div class="cxp__body"><div class="cxp__side">' +
        '<div class="cxp__stage"><div class="cxp__sh"><span>Nivel de preparación</span><b>' + STAGES[st] + '</b></div><div class="cxp__bar">' + bar + '</div><div class="cxp__lbl">' + lbl + '</div><span class="cxp__cnt">' + ct.m + ' de ' + PJ.length + ' piezas montadas</span></div>' +
        next + '</div>' +
        '<ul class="cxp__list" role="list">' + list + '</ul></div>' +
    '</div>';
  }
  function mount() {
    idx = findCar(); if (idx < 0) return;
    var grid = document.querySelector('section[data-cx-cg]'); if (!grid) return;
    box = document.createElement('section'); box.className = 'cxp'; box.id = 'mi-proyecto'; box.setAttribute('aria-label', 'Mi proyecto');
    grid.parentNode.insertBefore(box, grid);
    box.addEventListener('click', function (e) {
      var t = e.target.closest('[data-cxp-set],[data-cxp-tab]'); if (!t) return;
      if (t.hasAttribute('data-cxp-tab')) { tab = t.getAttribute('data-cxp-tab'); return render(); }
      var kv = t.getAttribute('data-cxp-set').split('|'), d = load(), c = d.cars[idx]; if (!c) return;
      if (!c.p || typeof c.p !== 'object') c.p = {};
      if (c.p[kv[0]] === kv[1]) delete c.p[kv[0]]; else c.p[kv[0]] = kv[1];
      save(d); render();
      var again = box.querySelector('[data-cxp-set="' + kv.join('|') + '"]'); if (again) again.focus();
    });
    render();
    if (location.hash === '#mi-proyecto') {
      var jump = function () { if (box) box.scrollIntoView({ block: 'start', behavior: 'instant' }); };
      if (document.readyState === 'complete') setTimeout(jump, 120); else window.addEventListener('load', function () { setTimeout(jump, 120); });
    }
  }
  function goTo() {
    if (!box) return;
    var x = document.querySelector('#CxGarage [data-cxg-close]'); if (x) x.click();
    render(); setTimeout(function () { box.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 30);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount); else mount();
  window.addEventListener('storage', function (e) { if (e.key === KEY && box) render(); });

  /* Botón «Mi proyecto» dentro del garaje: lleva a la página de su coche */
  var garage = document.getElementById('CxGarage');
  var info = garage && garage.querySelector('[data-cxg-info]');
  function viewIndex() { var sm = info && info.querySelector('small'); var m = sm && /Plaza\s+0*(\d+)/.exec(sm.textContent || ''); return m ? parseInt(m[1], 10) - 1 : -1; }
  function inject() {
    if (!info) return;
    var btns = info.querySelector('.cxg__btns'); if (!btns || btns.querySelector('[data-cxp-open]')) return;
    var c = load().cars[viewIndex()]; if (!c) return;
    var b = document.createElement('button'); b.type = 'button'; b.className = 'cxg__pbtn'; b.setAttribute('data-cxp-open', '');
    b.innerHTML = 'Mi proyecto <em>' + STAGES[stageOf(count(c).m)].toUpperCase() + '</em>';
    btns.insertBefore(b, btns.children[1] || null);
  }
  if (info) {
    new MutationObserver(inject).observe(info, { childList: true });
    info.addEventListener('click', function (e) {
      if (!e.target.closest('[data-cxp-open]')) return;
      e.stopPropagation();
      var i = viewIndex(), c = load().cars[i]; if (!c) return;
      var u = carUrl(c);
      if (box && isHere(u)) { idx = i; return goTo(); }
      location.href = u + '#mi-proyecto';
    });
    inject();
  }
  window.CxProyectoApp = { render: render, go: goTo };
})();
